export { default } from './CircularInfinite';
